import styled from 'styled-components';
import { HeColours } from '../../../../../../common/styles/HeColours';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { Breakpoint, FontWeight, PRESSABLE } from '../../../../../../common/styles/constants';
import { CtaLink } from './Appointments.styles';

export const CtaButtonBoxWithExperiment = styled.div`
  align-items: center;
  align-self: stretch;
  ${PRESSABLE};
  background-color: ${ThemeColours.buttonPrimaryFill};
  border: none;
  border-radius: 36px;
  box-sizing: border-box;
  color: ${ThemeColours.buttonPrimaryText};
  display: flex;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 1em;
  margin: 6px 0px;
  padding: 9px 16px;
  text-align: center;
  text-decoration: none;

  ${Breakpoint.MEDIUM} {
    align-self: center;
    font-weight: ${FontWeight.BOLD};
    margin-right: 24px;
  }
`;

export const TapTarget = styled(CtaLink)`
  ${PRESSABLE};
  background-color: ${HeColours.gray[50]};
  border-radius: 0;
  margin-right: 16px;
  padding: 0;
  text-align: center;
  text-decoration: none;
`;
